import { useState } from 'react';
import NoSayList from './NoSayList';
import EmbeddingSearchGuardrailsSection from './EmbeddingSearchGuardrailsSection';
import RedactionSettingsSection from './RedactionSettingsSection';

const GuardrailSession = () => {
    const [activeTab, setActiveTab] = useState('noSayList');

    const tabs = [
        { id: 'noSayList', name: 'Chat Moderation' },
        { id: 'redaction', name: 'Message Redaction' },
        { id: 'embeddingSearch', name: 'Case In-sensitive Tokens' },
    ];

    return (
        <div className="flex flex-col md:flex-row bg-gray-50">
            {/* Sidebar for Tabs */}
            <div className="w-full md:w-48 bg-white border-b md:border-b-0 border-gray-200 pr-4">

                <nav className="flex md:flex-col">
                    {tabs.map((tab) => (
                        <button
                            key={tab.id}
                            onClick={() => setActiveTab(tab.id)}
                            className={`p-2 text-left text-sm font-medium ${activeTab === tab.id
                                ? 'bg-indigo-50 border-l-4 border-indigo-500 text-indigo-700 '
                                : 'text-gray-600 ml-1 hover:bg-gray-50 hover:text-gray-900'
                                } w-full`}
                        >
                            {tab.name}
                        </button>
                    ))}
                </nav>
            </div>

            {/* Content Area */}
            <div className="flex-1 p-6 ">
                {activeTab === 'noSayList' && (
                    <NoSayList />
                )}
                {activeTab === 'embeddingSearch' && (
                    <EmbeddingSearchGuardrailsSection />
                )}
                {activeTab === 'redaction' && (
                    <RedactionSettingsSection />
                )}
            </div>
        </div>
    );
};

export default GuardrailSession;
